// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","title":"_2kiP8m9BCIds-CHQDvgWuX _2IbHD4FVxtBnbNHEUw2mS3","smallMaxWidth":"991px","cardContainer":"_10Hy5el9wo62UvAnUIbR9n","productCard":"_256AS_22oBtHMZeOxx1B6m"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/other-products-section/OtherProductsSection.css
// module id = 1021
// module chunks = 1